import { render, staticRenderFns } from "./ElectionStatus.vue?vue&type=template&id=537d944c&scoped=true"
import script from "./ElectionStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./ElectionStatus.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537d944c",
  null
  
)

export default component.exports